import RecognitionSearchBarResult from "./RecognitionSearchBarResult";

export default RecognitionSearchBarResult;
